import React from 'react';

interface RegistrationInfoLabelProps {
  personalDataVerified: boolean;
}

export default function RegistrationInfoLabel({ personalDataVerified }: RegistrationInfoLabelProps) {
  if (personalDataVerified) {
    return <span>Zaměstnancem Sokola</span>;
  }

  return <span>Online</span>;
}
